export default "__VITE_ASSET__e78c5e02__"